<template>
  <form-section id="signature" :headline="$t('form.signature.legend')">
    <datepicker-wrapper id="signature_date" :label="$t('form.signature.date.label')">
      <datepicker
        id="signature_date"
        input-class="form-control datepicker"
        :placeholder="$t('form.signature.date.placeholder')"
        format="dd/MM/yyyy"
        @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
        v-model="signatureDate"
        :language="lang"
      ></datepicker>
    </datepicker-wrapper>
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection";
import DatepickerWrapper from "@/shared/components/DatepickerWrapper.vue";
import Datepicker from "vuejs-datepicker";
import { da } from "vuejs-datepicker/dist/locale";
export default {
  components: {
    FormSection,
    DatepickerWrapper,
    Datepicker
  },
  data() {
    return {
      lang: da,
      signatureDate: ""
    };
  },
  watch: {
    signatureDate: {
      handler() {
        this.$store.commit("updateSignatureDate", this.signatureDate);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/SignatureInput.vue